<mdb-form-control class="form-fill">
    <input
      mdbInput
      [formControl]="control"
      [ngModel]="searchText | async"
      (ngModelChange)="searchText.next($event)"
      (keydown.enter)="onOptionsSetKeydown()" 
      [mdbAutocomplete]="autocomplete"
      type="text"
      #chipsAutocomplete
      id="autocomplete"
      class="form-control form-control--paybee "
      maxlength="48"
    />
    <label mdbLabel class="form-label form-label--paybee" [ngStyle]="required && control.touched && list.length < 1 && {'color': 'red'} || null" for="autocomplete">{{label}}</label>
  </mdb-form-control>

  <mdb-autocomplete #autocomplete="mdbAutocomplete">
    <mdb-option (click)="onOptionsSetKeydown()" *ngFor="let option of results | async" [value]="option">
      {{ option }}
    </mdb-option>
    <div *ngIf="notFound && isShowPromp" class="autocomplete-no-results">Press Enter to add new Tag</div>
  </mdb-autocomplete>

  <div class="chips-list">   
    <div *ngFor="let item of list; let i = index" class="chips-item">  
      <span> {{item}} </span>
      <app-icon-delete-chips (click)="dropOptionChips(i)"></app-icon-delete-chips>
    </div> 
</div> 
